module.exports = __webpack_public_path__ + "5d810fc5b4124c80251fb9288f691032.jpg";